import request from '@/utils/request';

/**
 * 社保政策查询
 * @param {*} params
 * @returns
 */
export function getPage(params) {
  return request({
    url: '/api/manage/social/insurance/policy/page',
    method: 'get',
    params
  })
}


/**
 * 社保政策发布记录查询
 * @param {*} params
 * @returns
 */
export function getPublishedList(params) {
  return request({
    url: `/api/manage/social/insurance/policy/published/records/list`,
    method: 'get',
    params
  })
}

/**
 * 社保政策发布记录详情
 * @param {*} id
 * @returns
 */
export function getPublishedDetail(id) {
  return request({
    url: `/api/manage/social/insurance/policy/${id}`,
    method: 'get',
  })
}

/**
 * 社保政策发布记录查询
 * @param {*} params
 * @returns
 */
export function getPublishedSocialInsurancePolicy(params) {
  return request({
    url: `/api/manage/social/insurance/policy/page`,
    method: 'get',
    params
  })
}

export default {
  getPage,
  getPublishedDetail,
  getPublishedSocialInsurancePolicy
}
